export const en = {
    show_on_a_map: 'Show on a map',
    location_in_ymap: 'location on Yandex Maps',
};
